import { render, staticRenderFns } from "./VariableWidth.vue?vue&type=template&id=ae1b1afe"
import script from "./VariableWidth.vue?vue&type=script&lang=js"
export * from "./VariableWidth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports